/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthorizationLeadScreenerLeadInfoRace } from './PalAuthorizationLeadScreenerLeadInfoRace';
import {
    PalAuthorizationLeadScreenerLeadInfoRaceFromJSON,
    PalAuthorizationLeadScreenerLeadInfoRaceFromJSONTyped,
    PalAuthorizationLeadScreenerLeadInfoRaceToJSON,
} from './PalAuthorizationLeadScreenerLeadInfoRace';
import type { PalAuthorizationLeadScreenerLeadInfoState } from './PalAuthorizationLeadScreenerLeadInfoState';
import {
    PalAuthorizationLeadScreenerLeadInfoStateFromJSON,
    PalAuthorizationLeadScreenerLeadInfoStateFromJSONTyped,
    PalAuthorizationLeadScreenerLeadInfoStateToJSON,
} from './PalAuthorizationLeadScreenerLeadInfoState';

/**
 * 
 * @export
 * @interface PalAuthorizationLeadScreenerLeadInfo
 */
export interface PalAuthorizationLeadScreenerLeadInfo {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    s3_photo_key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    photo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    marital_status?: PalAuthorizationLeadScreenerLeadInfoMaritalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    primary_language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    contact_method_preference?: PalAuthorizationLeadScreenerLeadInfoContactMethodPreferenceEnum;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    current_address?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    race_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    religion?: PalAuthorizationLeadScreenerLeadInfoReligionEnum;
    /**
     * 
     * @type {PalAuthorizationLeadScreenerLeadInfoRace}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    race?: PalAuthorizationLeadScreenerLeadInfoRace;
    /**
     * 
     * @type {PalAuthorizationLeadScreenerLeadInfoState}
     * @memberof PalAuthorizationLeadScreenerLeadInfo
     */
    state?: PalAuthorizationLeadScreenerLeadInfoState;
}


/**
 * @export
 */
export const PalAuthorizationLeadScreenerLeadInfoMaritalStatusEnum = {
    Single: 'single',
    DomesticPartner: 'domestic_partner',
    Married: 'married',
    Separated: 'separated',
    Divorced: 'divorced',
    Widowed: 'widowed',
    UnknownDeclined: 'unknown_declined'
} as const;
export type PalAuthorizationLeadScreenerLeadInfoMaritalStatusEnum = typeof PalAuthorizationLeadScreenerLeadInfoMaritalStatusEnum[keyof typeof PalAuthorizationLeadScreenerLeadInfoMaritalStatusEnum];

/**
 * @export
 */
export const PalAuthorizationLeadScreenerLeadInfoContactMethodPreferenceEnum = {
    Email: 'Email',
    Text: 'Text',
    Call: 'Call',
    Other: 'Other'
} as const;
export type PalAuthorizationLeadScreenerLeadInfoContactMethodPreferenceEnum = typeof PalAuthorizationLeadScreenerLeadInfoContactMethodPreferenceEnum[keyof typeof PalAuthorizationLeadScreenerLeadInfoContactMethodPreferenceEnum];

/**
 * @export
 */
export const PalAuthorizationLeadScreenerLeadInfoReligionEnum = {
    _7thDayAdventist: '7th Day Adventist',
    Atheist: 'Atheist',
    Agnostic: 'Agnostic',
    Apolistic: 'Apolistic',
    Apostolic: 'Apostolic',
    AssemblyOfGod: 'Assembly of God',
    Baptist: 'Baptist',
    Buddhist: 'Buddhist',
    Catholic: 'Catholic',
    Congregational: 'Congregational',
    Christian: 'Christian',
    ChristianScientist: 'Christian Scientist',
    ChurchOfChrist: 'Church of Christ',
    ChristianMissionaryAlliance: 'Christian Missionary Alliance',
    ChurchOfTheNazarene: 'Church of the Nazarene',
    ChristianReformed: 'Christian Reformed',
    Covenant: 'Covenant',
    DisciplesOfChrist: 'Disciples of Christ',
    Episcopalian: 'Episcopalian',
    Evangelical: 'Evangelical',
    FirstAssembly: 'First Assembly',
    GreekOrthodox: 'Greek Orthodox',
    Hinduism: 'Hinduism',
    Islam: 'Islam',
    Judaism: 'Judaism',
    JehovahsWitness: 'Jehovah\'s Witness',
    Lutheran: 'Lutheran',
    ChurchOfTheLatterDaySaints: 'Church of the Latter Day Saints',
    Methodist: 'Methodist',
    Mennonite: 'Mennonite',
    Mormon: 'Mormon',
    Moravian: 'Moravian',
    None: 'None',
    NonDenominational: 'Non-Denominational',
    Orthodox: 'Orthodox',
    Protestant: 'Protestant',
    Pentecostal: 'Pentecostal',
    Presbyterian: 'Presbyterian',
    Quaker: 'Quaker',
    Scientology: 'Scientology',
    Taoist: 'Taoist',
    Traditional: 'Traditional',
    Unitarian: 'Unitarian',
    Unknown: 'Unknown'
} as const;
export type PalAuthorizationLeadScreenerLeadInfoReligionEnum = typeof PalAuthorizationLeadScreenerLeadInfoReligionEnum[keyof typeof PalAuthorizationLeadScreenerLeadInfoReligionEnum];


/**
 * Check if a given object implements the PalAuthorizationLeadScreenerLeadInfo interface.
 */
export function instanceOfPalAuthorizationLeadScreenerLeadInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadScreenerLeadInfoFromJSON(json: any): PalAuthorizationLeadScreenerLeadInfo {
    return PalAuthorizationLeadScreenerLeadInfoFromJSONTyped(json, false);
}

export function PalAuthorizationLeadScreenerLeadInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadScreenerLeadInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        's3_photo_key': !exists(json, 's3_photo_key') ? undefined : json['s3_photo_key'],
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
        'marital_status': !exists(json, 'marital_status') ? undefined : json['marital_status'],
        'primary_language': !exists(json, 'primary_language') ? undefined : json['primary_language'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'contact_method_preference': !exists(json, 'contact_method_preference') ? undefined : json['contact_method_preference'],
        'current_address': !exists(json, 'current_address') ? undefined : json['current_address'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'race_id': !exists(json, 'race_id') ? undefined : json['race_id'],
        'religion': !exists(json, 'religion') ? undefined : json['religion'],
        'race': !exists(json, 'race') ? undefined : PalAuthorizationLeadScreenerLeadInfoRaceFromJSON(json['race']),
        'state': !exists(json, 'state') ? undefined : PalAuthorizationLeadScreenerLeadInfoStateFromJSON(json['state']),
    };
}

export function PalAuthorizationLeadScreenerLeadInfoToJSON(value?: PalAuthorizationLeadScreenerLeadInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        's3_photo_key': value.s3_photo_key,
        'photo_url': value.photo_url,
        'marital_status': value.marital_status,
        'primary_language': value.primary_language,
        'phone_number': value.phone_number,
        'email': value.email,
        'contact_method_preference': value.contact_method_preference,
        'current_address': value.current_address,
        'state_id': value.state_id,
        'race_id': value.race_id,
        'religion': value.religion,
        'race': PalAuthorizationLeadScreenerLeadInfoRaceToJSON(value.race),
        'state': PalAuthorizationLeadScreenerLeadInfoStateToJSON(value.state),
    };
}

